/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ListInput/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import MultiSelectInput from './MultiSelectInput/index'
import React from 'react'
import ToggleInput from './ToggleInput/index'



/** @type {import('Simple/types.js').View} */
export default function ListInput({
  children,
  viewPath = "/DesignSystem/TysiaInputQuestion/ListInput",
  isToggle,
  onChange,
  value,
  isInvalid,
  size,
  disabled,
  maxWidth,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  zIndex = "auto",
  showAlert = true
  
}) {
  return (<React.Fragment
>
<fromFlow.When is={!isToggle}>
<MultiSelectInput
  viewPath={`${viewPath}/MultiSelectInput`}
 onChange={onChange}
 value={value}
 isInvalid={isInvalid}
 size={size}
 disabled={disabled}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 zIndex={zIndex}
/>
</fromFlow.When>
<fromFlow.When is={isToggle}>
<ToggleInput
  viewPath={`${viewPath}/ToggleInput`}
 showAlert={showAlert}
 disabled={disabled}
 size={size}
 maxWidth={maxWidth}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}